import React, { memo, useCallback } from 'react'
import { Nav } from 'react-bootstrap'

const statusBadge = (isOn, updatePage) => (
  <span className={`badge ms-2 bg-${isOn ? 'success' : 'danger'} ${updatePage ? String(new Date().getTime()) : ''}`} onClick={updatePage}>
    {isOn ? 'ON' : 'OFF'}
  </span>
)

const TablesNavigation = memo((props) => {
  const {
    isHTR,
    isAPV,
    campaign,
    anyClusterAuctions,
    anyPPCAuctions,
    currentTab,
    updatePage,
    setCurrentTab,
    numberOfClusterAuctions,
    isActivePPCAuctions,
    isActiveBrandingAuctions,
    anyActiveEmailsBid,
    multilangCampaignStatus,
    multilangHelpModal,
    closeHelpModal,
    interval = false,
    // anyActiveContentBid,
    // isContentAuctionsData
  } = props

  const switchTab = useCallback((tab) => () => {
    setCurrentTab(tab)
  }, [setCurrentTab])

  const tabsConfig = [
    {
      key: 'cluster',
      show: anyClusterAuctions,
      label: `${multilangCampaignStatus?.cluster} (${numberOfClusterAuctions})`,
    },
    {
      key: 'specific',
      show: !isAPV && anyPPCAuctions,
      label: isHTR
        ? <>
            {multilangCampaignStatus?.htr_specific}
            {statusBadge(isActivePPCAuctions && campaign?.ppc_active && !campaign?.ppc_paused, updatePage)}
          </>
        : multilangCampaignStatus.specific,
    },
    // {
    //   key: 'content',
    //   show: isHTR && !interval && isContentAuctionsData,
    //   label: 
    //       <>
    //         {multilangCampaignStatus?.content}
    //         {statusBadge(anyActiveContentBid && campaign?.ppc_active && !campaign?.ppc_paused, updatePage)}
    //       </>
    // },
    {
      key: 'branding',
      show: !isAPV,
      label: isHTR
        ? <>
            {multilangCampaignStatus?.htr_branding}
            {statusBadge(isActiveBrandingAuctions && campaign?.ppc_active && !campaign?.ppc_paused, updatePage)}
          </>
        : multilangCampaignStatus.branding,
    },
    {
      key: 'emails',
      show: !isAPV,
      label: isHTR
        ? <>
            {multilangCampaignStatus?.htr_emails}
            {statusBadge(anyActiveEmailsBid && campaign?.ppc_active && !campaign?.ppc_paused, updatePage)}
          </>
        : multilangCampaignStatus.emails,
    },
    {
      key: 'interval',
      show: isHTR && interval,
      label: multilangCampaignStatus.interval,
    }
  ]

  return (
    <div className="d-flex align-items-center">
      <Nav className={`nav-line flex-grow-1 ${isHTR ? 'htr' : ''}`}>
        {tabsConfig
          .filter(tab => tab && tab.show)
          .map(tab => (
            <Nav.Link
              key={tab.key}
              className={currentTab === tab.key ? 'active' : ''}
              onClick={switchTab(tab.key)}
            >
              <span className="d-flex align-items-center">
                {tab.label}
              </span>
            </Nav.Link>
          ))}

        {!isHTR && (
          <Nav.Link className="ms-auto text-primary" onClick={closeHelpModal} id="ppc-bidding-rules">
            <i className="ri-question-line" /> {multilangHelpModal.title}
          </Nav.Link>
        )}
      </Nav>
    </div>
  )
})

export default TablesNavigation
